import React from "react";
import { ScrollView } from "react-native";
import { RefreshControl } from "./RefreshControl";
import { useRefresh } from "../hooks/refresh";
import ScreenCardHeadband, { ScreenCardHeadbandProps } from "../screens/ScreenCardHeadband";

type SimplePageContentProps = {
    children: React.ReactNode;
    refresh?: () => Promise<unknown>;
    headband?: ScreenCardHeadbandProps;
};

const SimplePageContent = ({ children, refresh, headband }: SimplePageContentProps) => {
    const { localRefresh, refreshing } = useRefresh({ refresh });

    return (
        <ScrollView
            style={{ flex: 1 }}
            refreshControl={
                localRefresh && <RefreshControl onRefresh={localRefresh} refreshing={refreshing} />
            }
        >
            {headband && <ScreenCardHeadband {...headband} />}
            {children}
        </ScrollView>
    );
};

export default SimplePageContent;
